import format from 'date-fns/format';
import some from 'lodash/some';

import type { CustomContentPropertiesPage_experimentalCustomContentPropertiesPage_results_operations as operationType } from './__types__/CustomContentPropertiesPage';
import { CustomContentSources } from './CustomContentSources';

export const formatDate = (date: string | null | undefined): string => {
	if (!date) {
		return '';
	}
	let formattedDate = '';
	try {
		formattedDate = format(new Date(date), 'PP kk:mm');
	} catch (e) {}
	return formattedDate;
};

export const getCustomContentSource = (type: string): CustomContentSources | undefined => {
	if (!type) {
		return;
	}

	const [prefix] = type.split(':');
	if (prefix === 'ac') {
		return CustomContentSources.CONNECT;
	}

	if (prefix === 'forge') {
		return CustomContentSources.FORGE;
	}
};

export const ableToDeleteCustomContent = ({
	operations,
	targetType,
}: {
	operations: operationType[];
	targetType: string;
}) => some(operations, { targetType, operation: 'delete' });

const ABSOLUTE_PATH_REGEXP = new RegExp('^([a-z]+:)?//', 'i');
export const getIcon = (module): string => {
	let icon: string = module?.uiSupport?.icons?.item?.url;

	if (!ABSOLUTE_PATH_REGEXP.test(icon)) {
		icon = module?.baseUrl + icon;
	}

	return icon;
};

export const getCustomContentTypeForConnect = (app): string => {
	return `ac:${app.addonKey}:${app.key}`;
};
